
<div class="row">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info">Exam Structures</h3></div>
  <div class="col-sm-12 text-end alert">
      <a [routerLink]="['/admin/exam/format/edit',0]" class ="btn btn-primary"> <i class="fa fa-plus"></i> Add New Exam Format</a>
  </div>
</div>
<div class="table-responsive" *ngIf="examFormats.length>0">
<span [appMath]="''"></span>
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
  <thead>
  <tr>
  <th>Country</th>
  <th>Name</th>
  <th>Total Marks</th>
  <th>Sections</th>
  <th></th>

  </tr>
  </thead>

  <tbody>

  <tr *ngFor="let examStructure of examFormats;">
      <td>{{examStructure.countryName}}</td>

     <td>


         {{examStructure.formalName}}

      </td>

     <td>{{examStructure.totalMarks}}</td>
     <td>
      <ul>
        <li *ngFor="let section of examStructure.examSections">
          {{section.formalName}} | {{section.numberOfQuestions}} Questions for {{section.markPerQuestion}} Marks each
          <button (click)="removeSection(section.server_exam_section_id)" class="btn btn-link me-2">
            Remove Section
           </button>
           <a [routerLink]="['/admin/exam/section/new',examStructure.server_exam_structure_id,section.server_exam_section_id]">
            Edit Section
           </a>
        </li>
      </ul>

      <div class="text-center">
        <a [routerLink]="['/admin/exam/section/new',examStructure.server_exam_structure_id,0]">
          Add Section
         </a>
      </div>

      </td>
      <td>
        <a [routerLink]="['/admin/exam/format/edit',examStructure.server_exam_structure_id]">
          <i class="fa fa-edit"></i> Edit
         </a>
      </td>

  </tr>

  </tbody>

</table>

</div>

<app-spinner *ngIf="(examFormats.length==0) && loading"></app-spinner>
<div *ngIf="(examFormats.length==0) && !loading" class="text-center">No Records Found </div>

<hr/>
<div class="text-center" >
  <a [routerLink]="['/admin/exam/format/edit',0]">Add New Exam Format</a>
</div>


